module.exports = __webpack_public_path__ + "assets/img/Travel_002.dc07144c-ps.jpg";